import { render } from "./TeoSettings.vue?vue&type=template&id=0490c1de"
import script from "./TeoSettings.vue?vue&type=script&lang=js"
export * from "./TeoSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__